require('./Header.scss');

const React = require('react'),
    ActionTypes = require('constants/AppConstants').ActionTypes,
    {t} = require('services/i18nextWrapper'),
    AppDispatcher = require('dispatcher/SchedulerAppDispatcher'),
    MenuItem = require('material-ui/lib/menus/menu-item'),
    DashboardServiceCache = require('services/DashboardServiceCache'),
    Constants = require('constants/AppConstants'),
    CustomDialog = require('components/Commons/Dialog/CustomDialogHolder'),
    MenuDivider = require('material-ui/lib/menus/menu-divider'),
    Security = require('services/Security').auth,
    SessionStore = require('stores/SessionStore'),
    ContentUtils = require('utils/ContentUtils'),
    SettingModal = require('./SettingModal/SettingModal'),
    PositionUtils = require('utils/PositionUtils'),
    categories = require('constants/AppConstants').Analytics.categories,
    actions = require('constants/AppConstants').Analytics.actions,
    $ = require('jquery'),
    ga = require('react-ga'),
    DASHBOARD_ID ='#dashboard-id',
    {AppBar, IconMenu, Avatar, FontIcon, IconButton} = require('material-ui');

const Header = React.createClass({displayName: "Header",


    getInitialState() {
        return {
            isSettingModalOpen: false
        };
    },

    _toggleSettingModalShow() {
        this.setState(prevState => {
            return {
                isSettingModalOpen: !prevState.isSettingModalOpen
            };
        });
    },

    _onExit() {
        if (DashboardServiceCache.getPendingOperations().length > 0) {
            CustomDialog.showWarningConfirmation(t('warning'), t('notification_warning_leave_dashboard_before_auto_saved'),
                () => {
                    this._logout();
                },
                t('button_label_continue'),
                t('button_label_cancel'));
        } else {
            this._logout();
        }
    },

    _logout() {
        Security.logout();
        ga.event({
            category: categories.APPLICATION,
            action: actions.SIGN_OUT,
            label: 'Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
        });
    },

    _printDashboard(e) {
        e.preventDefault();

        // remove selection dashboard to avoid problem when print the orders
        AppDispatcher.dispatch({type: ActionTypes.FORCE_CLEAN_ORDER_SELECTED_DASHBOARD});

        setTimeout(() => {
            const useWidth = $(DASHBOARD_ID).prop('scrollWidth');
            let scrollHeight = $(PositionUtils.getParentScroll(document.querySelector(DASHBOARD_ID))).prop('scrollHeight');
            let scrollY = -Math.abs(document.documentElement.scrollTop);
            let useHeight = scrollHeight;

            html2canvas(document.querySelector(DASHBOARD_ID), {width: useWidth, height: useHeight, scrollY}).then(function(canvas) {
                ReImg.fromCanvas(canvas).downloadPng();
            });
        }, 2000);
    },

    render() {

        const {isLogged, onClickLeftMenuBar, onClickRightMenuBar} = this.props;
        const isDashboardPage = window.location.href.includes('dashboard');
        let appBarStyle = 'app-bar',
            buttonRightBar;
        let appBarContent = null;


        if (isLogged) {
            const iconButtonElement = (
                React.createElement(IconButton, {className: "right-option-menu", touch: true}, 
                    React.createElement(Avatar, {className: "avatar-applicant", 
                            src: Security.getCurrentApplicantLogoSrc()}, Security.getCurrentUserName())
                )
            );

            const exitIcon = (React.createElement(FontIcon, {className: "material-icons"}, "exit_to_app"));
            const settingIcon = (React.createElement(FontIcon, {className: "material-icons"}, "settings"));
            const printIcon = (React.createElement(FontIcon, {className: "material-icons"}, "print"));

            appBarStyle += ' is-login';

            buttonRightBar = isDashboardPage ? getIconMenu.call(this, iconButtonElement, settingIcon, printIcon, exitIcon) : (
                React.createElement(IconMenu, {className: "right-menu", ref: "rightMenu", iconButtonElement: iconButtonElement}, 
                    React.createElement(Avatar, {className: "avatar-applicant", 
                            src: Security.getCurrentApplicantLogoSrc()}, Security.getCurrentUserName()), 
                    React.createElement(MenuDivider, null), 
                    React.createElement(MenuItem, {
                        value: "settings", 
                        leftIcon: settingIcon, 
                        primaryText: t('dashboard_menu_settings'), 
                        onClick: this._toggleSettingModalShow}
                    ), 
                    React.createElement(MenuDivider, null), 
                    React.createElement(MenuItem, {
                        value: "exit", 
                        leftIcon: exitIcon, 
                        primaryText: t('dashboard_menu_exit'), 
                        onClick: this._onExit}
                    )
                )
            );

            if (
                !(SessionStore.getCurrentLicense() === Constants.LICENSE_FULL_VERSION || SessionStore.isBasePaidVersion())
            ) {
                appBarContent = (
                    React.createElement("div", {className: "subscribe-message"}, 
                        React.createElement("a", {target: "_blank", href: "https://www.brewplanner.com/payment"}, React.createElement("button", {className: "BPButton", style: { color: 'white', fontWeight: 500}}, "Upgrade")), " ", 
                        React.createElement("span", null, Math.floor(14 - Math.floor(SessionStore.getAccountAgeDays())), " days left in you free trial. ")
                    )
                )
            }

            if (SessionStore.isBasePaidVersion() && SessionStore.isTrialVersionActive()) {
                appBarContent = (
                    React.createElement("div", {className: "subscribe-message"}, 
                        React.createElement("span", null, "You are currently on the Base plan. There are ", Math.floor(14 - Math.floor(SessionStore.getAccountAgeDays())), " days left in your trial period for MRP! To avoid disruptions, upgrade to the ", React.createElement("a", {href: "https://buy.stripe.com/aEUdRCasg5QKfhm6oo"}, "MRP"), " plan!")
                    )
                );
            }

        } else {
            buttonRightBar = null;
        }

        return (
            React.createElement("div", {className: 
                'bp-header ' +
                (Security.loggedIn() ? ' is-login' : '')
            }, 
                React.createElement(SettingModal, {
                    isOpen: this.state.isSettingModalOpen, 
                    onClose: this._toggleSettingModalShow}
                ), 
                
                React.createElement(AppBar, {
                    className: appBarStyle, 
                    onLeftIconButtonTouchTap: onClickLeftMenuBar, 
                    onRightIconButtonTouchTap: onClickRightMenuBar, 
                    iconElementRight: 
                        buttonRightBar, 
                    
                    style: {position: 'fixed', top: 0, backgroundColor: '#101112'}, 
                    ref: "mainAppBar"
                }, 
                    appBarContent
                )
            )
        );
    }
});

function getIconMenu(iconButtonElement, settingIcon, printIcon, exitIcon) {
    return React.createElement(IconMenu, {className: "right-menu", ref: "rightMenu", iconButtonElement: iconButtonElement}, 
        React.createElement(Avatar, {className: "avatar-applicant", 
                src: Security.getCurrentApplicantLogoSrc()}, Security.getCurrentUserName()), 
        React.createElement(MenuDivider, null), 
        React.createElement(MenuItem, {
          value: "settings", 
          leftIcon: settingIcon, 
          primaryText: t('dashboard_menu_settings'), 
          onClick: this._toggleSettingModalShow}
        ), 
        React.createElement(MenuItem, {
          value: "print", 
          leftIcon: printIcon, 
          primaryText: t('dashboard_menu_print_dashboard'), 
          onClick: this._printDashboard}
        ), 
        React.createElement(MenuDivider, null), 
        React.createElement(MenuItem, {
          value: "exit", 
          leftIcon: exitIcon, 
          primaryText: t('dashboard_menu_exit'), 
          onClick: this._onExit}
        )
    );
}


module.exports = {
    getIconMenu,
    Header,
};



/** WEBPACK FOOTER **
 ** ./src/components/Header/Header.jsx
 **/